import { AxiosInstance } from 'axios';
import config from 'config/Config';
import { initAxios } from 'utils/axios';
import { TaskBundleCreationData } from 'utils/customTypes';
import { RawPreviewTaskBundleDatesResponse } from 'types/store/tasksBundle';

class TaskBundleAPI {
  instance: AxiosInstance;
  instanceV3: AxiosInstance;
  constructor() {
    this.instance = initAxios(config.get('backendURL'));
    this.instanceV3 = initAxios(config.get('backendURL'), 'dt');
  }

  fetchTaskBundles = async () => {
    const { data } = await this.instance.get('/taskBundles');
    return data;
  };

  fetchTaskBundlesV3 = async () => {
    const { data } = await this.instanceV3.get('/v3/task-bundles');
    return data;
  };

  createTaskBundle = async (bundleData: TaskBundleCreationData) => {
    const { data } = await this.instance.post('/taskBundles', bundleData);
    return data;
  };

  attachTaskBundleToProject = async (
    taskBundleId: string,
    projectId: string
  ) => {
    const { data } = await this.instance.post(
      `/project/${projectId}/assignTaskBundle/${taskBundleId}`
    );
    return data;
  };

  attachTaskBundleToProjectV3 = async (
    taskBundleId: string,
    projectId: string,
    applyDates?: boolean
  ) => {
    const { data } = await this.instanceV3.post(
      `/v3/projects/${projectId}/bundle-assignments`,
      { bundleIds: [taskBundleId] },
      applyDates ? { headers: { 'x-apply-bundle-dates': 'true' } } : undefined
    );
    return data;
  };

  createTaskBundleV3 = async (bundleData: TaskBundleCreationData) => {
    const { data } = await this.instanceV3.post('/v3/task-bundles', {
      name: bundleData.name,
      description: bundleData.description ?? null,
    });
    return data;
  };

  deleteTaskBundle = async (bundleId: string) => {
    const { data } = await this.instance.delete(`/taskBundles/${bundleId}`);
    return data;
  };

  deleteTaskBundleV3 = async (bundleId: string) => {
    const { data } = await this.instanceV3.delete(
      `/v3/task-bundles/${bundleId}`
    );
    return data;
  };

  previewTaskBundleDates = async (
    taskBundleId: string,
    projectStartDate: string
  ) => {
    const { data } =
      await this.instanceV3.get<RawPreviewTaskBundleDatesResponse>(
        `/v3/task-bundles/${taskBundleId}/preview`,
        { params: { projectStartDate } }
      );
    return data;
  };
}

const taskBundleAPI = new TaskBundleAPI();

export default taskBundleAPI;
